import { type ReactNode, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { Menu as PrimeMenu } from 'primereact/menu';
import { Button, ButtonProps } from '../Button/Button';
import { Icon } from '../Icon/Icon';
import {
    MenuItem as PrimeMenuItem,
    MenuItemCommandEvent as PrimeMenuItemCommandEvent,
} from 'primereact/menuitem';
import clsx from 'clsx';

export type MenuItem = PrimeMenuItem;
export type MenuItemCommandEvent = PrimeMenuItemCommandEvent;

export interface MenuProps {
    items?: MenuItem[];
    buttonProps?: ButtonProps;
    'data-testid'?: string;
}

// It throws error, because PrimeNg uses 'aria-hidden=true' - this topic is already addressed in their github issues
export function Menu(props: MenuProps): ReactNode {
    const { items, buttonProps, 'data-testid': dataTestId } = props || {};
    const menuRef = useRef<PrimeMenu>(null);
    const toastRef = useRef<Toast>(null);
    const [isActive, setIsActive] = useState<boolean>(false);
    const buttonClassName = clsx(
        {
            active: isActive,
        },
        buttonProps?.className,
    );
    const menuClassName = clsx(
        {
            contrast: buttonProps?.contrast,
        },
        'context-menu',
    );

    return (
        <>
            <Toast ref={toastRef} />
            <PrimeMenu
                className={menuClassName}
                model={items}
                popup
                ref={menuRef}
                id="popup_menu_left"
                onShow={() => setIsActive(true)}
                onBlur={() => setIsActive(false)}
            />
            <Button
                icon={<Icon name="more_vert" />}
                text={!Boolean(buttonProps)}
                type="button"
                iconButton
                data-testid={dataTestId}
                {...buttonProps}
                onClick={(event) => {
                    event.stopPropagation();

                    if (buttonProps?.onClick) {
                        buttonProps.onClick(event);
                    }

                    menuRef.current?.toggle(event);
                }}
                className={buttonClassName}
            />
        </>
    );
}
